import { NamedNode } from './node';
import { Entry } from './entry';

export class AccessRule extends NamedNode {
    entry?: Entry;
    target?: any;
}
